//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('poLoadPlan', {
//        templateUrl: 'views/components/views/poLoadPlan/poLoadPlan.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['stateService', 'utilityService', 'poLoadPlanService', 'logisticService', 'ttGridFactory', 'rememberService', function (stateService, utilityService, poLoadPlanService, logisticService, ttGridFactory, rememberService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;

//            let variableNames = {
//                businessco_no: '',
//                stockplace_id: '',
//                date_fom: '',
//                date_tom: '',
//                dateselector_index: ''
//            };

//            vm.model = {
//                gridReady: false,
//                setting: {},
//                selectListCompanies: [],
//                selectListStockPlaces: []
//            };

//            vm.grid = new ttGridFactory({
//                rememberId: 'w_poloadplan_grid',
//                kendo: {
//                    height: '100%',
//                    sortable: true,
//                    aggregate: true,
//                    pager: false,
//                    selectable: false,
//                    filterable: false
//                }
//            });
            
//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadSetting() {
//                vm.model.setting = (await poLoadPlanService.getSetting())[0];

//                Promise.all([
//                    loadStockPlaces()
//                ]).then(() => {
//                    loadGrid();
//                    Promise.resolve();
//                });
//            }

//            async function loadCompanies() {
//                vm.model.selectListCompanies = await logisticService.listCompanies();
//            }

//            async function loadStockPlaces() {
//                if (utilityService.validateParmsValue(vm.model.setting.businessco_no) !== true) return;

//                vm.model.selectListStockPlaces = await logisticService.listStocks({ businessco_no: vm.model.setting.businessco_no });
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region GRID PROCEDURE FUNCTION CALLS

//            async function loadGrid() {
//                vm.grid.dataTask.loadData = {
//                    method: 3675,
//                    parameters: vm.model.setting
//                };

//                vm.model.gridReady = true;

//                if (vm.grid.gridfunc !== null) vm.grid.gridfunc.rebind(false);
//            }

//            // #endregion GRID PROCEDURE FUNCTION CALLS

//            // #region REMEMBER VALUE MULTI PROCEDURE FUNCTION CALLS

//            function rememberFunc(id) {
//                Object.keys(variableNames).forEach((key) => {
//                    switch (key) {
//                        case '':
//                            break;
//                        default:
//                            variableNames[key] = 'w_' + stateService.getCurrentName() + '.' + key;
//                            break;
//                    }
//                });

//                if (utilityService.validateParmsValue(variableNames[id]) !== true) return;

//                let variableValue = null;

//                switch (id) {
//                    case 'businessco_no':
//                    case 'stockplace_id':
//                        if (utilityService.validateParmsValue(vm.model.setting[id], true) !== true) return;

//                        variableValue = vm.model.setting[id];
//                        break;
//                    case 'date_fom':
//                    case 'date_tom':
//                    case 'dateselector_index':
//                        if (utilityService.validateParmsValue(vm.model.setting[id]) !== true) return;

//                        variableValue = vm.model.setting[id];
//                        break;
//                    default:
//                        break;
//                }

//                return rememberService.remember(variableNames[id], variableValue);
//            }

//            // #endregion REMEMBER VALUE MULTI PROCEDURE FUNCTION CALLS

//            // #region FIELD DATE RANGE CHANGE FUNCTION

//            vm.onDateRangeChanged = function (startDate, endDate, dateInterval) {
//                vm.model.setting.date_fom = startDate;
//                vm.model.setting.date_tom = endDate;
//                vm.model.setting.dateselector_index = +dateInterval <= 0 ? vm.model.setting.dateselector_index : dateInterval;

//                if (vm.model.setting.date_fom) rememberFunc('date_fom');
//                if (vm.model.setting.date_tom) rememberFunc('date_tom');
//                if (vm.model.setting.dateselector_index) rememberFunc('dateselector_index');

//                if (vm.model.setting.date_fom && vm.model.setting.date_tom && vm.model.setting.dateselector_index) {
//                    vm.model.setting.date_fomtom = vm.model.setting.date_fom + vm.model.setting.date_tom;
//                    loadGrid();
//                }
//            };

//            // #endregion FIELD DATE RANGE CHANGE FUNCTION

//            // #region FIELD CHANGE MULTI FUNCTIONS

//            vm.onChanged = function (value, id) {
//                switch (id) {
//                    case 'businessco_no':
//                        if (utilityService.validateWatchValue(value, vm.model.setting.businessco_no) !== true) return;

//                        vm.model.setting.businessco_no = value;

//                        if (utilityService.validateParmsValue(vm.model.setting.businessco_no) !== true) return;

//                        Promise.all([
//                            rememberFunc('businessco_no'),
//                            loadStockPlaces()
//                        ]).then(() => {
//                            loadGrid();
//                            Promise.resolve();
//                        });
//                        break;
//                    case 'stockplace_id':
//                        if (utilityService.validateWatchValue(value, vm.model.setting.stockplace_id) !== true) return;

//                        vm.model.setting.stockplace_id = value;

//                        if (utilityService.validateParmsValue(vm.model.setting.stockplace_id, true) !== true) return;

//                        Promise.all([
//                            rememberFunc('stockplace_id')
//                        ]).then(() => {
//                            loadGrid();
//                            Promise.resolve();
//                        });
//                        break;
//                    default:
//                        utilityService.setValueToVariable(value);
//                        break;
//                }
//            };

//            // #endregion FIELD CHANGE MULTI FUNCTIONS

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//            	loadSetting();
//                loadCompanies();
//            };

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
